import styled, { css } from 'styled-components/macro';

import modularScale from 'styles/helpers/modular-scale';

export const LayoutWrapper = styled.div`
  display: flex;
  margin-bottom: ${(p): string => p.theme.spacing.medium};

  [data-menu-root],
  [data-menu-figure],
  [data-menu-list],
  [data-menu-button] {
    width: 100%;
  }
`;

export const ButtonContent = styled.div<any>`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: ${(p): string => p.theme.spacing.medium};
  background: ${(p: any): string =>
    p.isOpen ? p.theme.LightGrey : p.theme.VeryLightGrey};
  text-align: left;

  &:hover {
    background: ${(p): string => p.theme.LightGrey};
  }

  .chevron {
    align-self: center;
    margin-left: ${(p): string => p.theme.spacing.medium};
    transition: transform 200ms;
    transition-timing-function: ${(p): string => p.theme.timingFunction};
    transform: ${(p: any): string =>
      p.isOpen ? 'rotate(270deg)' : 'rotate(90deg)'};
  }

  .value {
    display: block;
    font-weight: 600;
  }
  .amount {
    display: block;
    font-size: ${modularScale(-1)};
    color: ${(p): string => p.theme.CasperGrey};
  }
`;

export const SideButton = styled.button.attrs({ type: 'button' })<any>`
  ${({ theme, flipIcon, disabled }): any => css`
    background: ${theme.Sand};
    padding: 0 ${theme.spacing.medium};
    transform: ${flipIcon ? 'rotate(180deg)' : null};

    &:hover,
    &:focus {
      background: ${disabled ? null : theme.VeryLightGrey};
    }
  `}
  span {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export const ListItemContent = styled.div`
  padding: ${(p): string => p.theme.spacing.small};
  margin: 0;
  display: flex;
  align-items: center;

  > div {
    margin-left: ${(p): string => p.theme.spacing.small};
  }

  .amount {
    display: block;
    color: ${(p): string => p.theme.CasperGrey};
    font-size: ${modularScale(-1)};
  }

  &:hover {
    background: ${(p): string => p.theme.Sand};
  }
`;
